interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  light?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "left",
  light = false,
}: SectionHeadingProps) {
  return (
    <div
      className={`mb-10 flex flex-col gap-3 ${
        align === "center" ? "items-center text-center" : "items-start text-left"
      }`}
    >
      <span
        className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1 text-sm ${
          light ? "bg-white/15 text-accent-400" : "bg-accent-100 text-accent-700"
        }`}
      >
        <i className="ri-sparkling-2-fill" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2
        className={`font-heading text-3xl md:text-4xl ${
          light ? "text-white" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`max-w-2xl text-sm leading-relaxed md:text-base ${
            light ? "text-white/75" : "text-foreground-600"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}